import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { closeModal } from "../../store/state/modals/reducer";
import type { RootState } from "../../store/state/rootReducer";
import type { AppDispatch } from "../../store/state/rootStore";

import MessageBox from "./MessageBox";

const modalLookupTable = {
  "message-box": MessageBox,
};

const ModalsContainer = (): JSX.Element => {
  const modals = useSelector((state: RootState) => state.modals.displayed);
  const dispatch = useDispatch<AppDispatch>();
  const handleClose = useCallback(() => dispatch(closeModal()), []);

  return (
    <>
      {modals.map(({ id, type, params }) => {
        const ModalComponent = modalLookupTable[type];
        return <ModalComponent key={id} isOpen={true} onClose={handleClose} {...params} />;
      })}
    </>
  );
};

export default ModalsContainer;
